import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BaseTableDirective } from 'src/app/shared/directives/base-table.directive';
import { Store } from '@ngxs/store';
import { GenericTableColumn } from '../../interfaces/genetic-table-column';
import { FieldType } from '../../interfaces/field-type.enum';
import { RowType } from '../../interfaces/raw-type.enum';
import { getNestedProperty } from '../../helpers/helpers';
import { IGenericTableRowDeletedEventData } from '../../interfaces/generic-table-row-deleted.interface';

@Component({
  selector: 'app-generic-table',
  templateUrl: './generic-table.component.html',
  styleUrls: ['./generic-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericTableComponent<T> extends BaseTableDirective implements OnInit {
  @Input() data: T[] = [];
  @Input() columns: GenericTableColumn<T>[] = [];
  @Input() loading: boolean;
  @Input() withDetailsOption: boolean = true;
  @Input() detailsControlName: string = 'Details';

  @Input() template: TemplateRef<any>;

  @Output() goToDetail: EventEmitter<string> = new EventEmitter();
  @Output() onRowClick: EventEmitter<number> = new EventEmitter();
  @Output() sorted: EventEmitter<T[]> = new EventEmitter();
  @Output() deleted: EventEmitter<IGenericTableRowDeletedEventData<T>> = new EventEmitter();

  FieldType = FieldType;
  RowType = RowType;

  tableColumns = {};
  /**
   *
   */
  constructor(protected store: Store) {
    super(store);
    
  }

  ngOnInit(): void {
    //propagate tableColumns for sorting to be able to move the arrow up and down
    if (this.columns) {
      this.tableColumns = this.columns
      .filter(column => column.sortable)
      .map(column => ({[column.field]: column.sortAsc}));
    }
  }

  sortByColumn(column: GenericTableColumn<T>): void {
    const sorted = this.sort(this.data, column.field.toString());
    this.data = sorted;
    this.sorted.next(this.data);
  }
  
  trackByFn(index, item) {
    return item?.id;
  }

  trackByColFn(index, item) {
    return item.field;
  }
  
  getNestedProperty(obj, path) {
    return getNestedProperty(obj, path);
  }

  deleteRow(index: number, item: T) {
    this.deleted.emit({index, item});
  }

}
